import { Mutation, Query } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { refreshToken } from "src/api/services/auth.service";
import { removeScrfToken, setScrfToken } from "./tokens";

let isRedirecting = false;
let isRefreshing = false;
let failedQueue: {
  query?: Query;
  mutation?: Mutation<unknown, unknown, unknown, unknown>;
  variables?: unknown;
}[] = [];

export interface IErrorResponse {
  message: string;
}

const errorHandler = (
  error: unknown,
  query?: Query,
  mutation?: Mutation<unknown, unknown, unknown, unknown>,
  variables?: unknown
) => {
  const status = (error as AxiosError<IErrorResponse>).response?.status!;
  const data = (error as AxiosError<IErrorResponse>).response?.data!;

  if (status === 401) {
    if (mutation) refreshTokenAndRetry(undefined, mutation, variables);
    else refreshTokenAndRetry(query);
  } else console.error(data?.message);
};

export const queryErrorHandler = (error: unknown, query: Query) => errorHandler(error, query);

export const mutationErrorHandler = (
  error: unknown,
  variables: unknown,
  mutation: Mutation<unknown, unknown, unknown, unknown>
) => errorHandler(error, undefined, mutation, variables);

const refreshTokenAndRetry = async (
  query?: Query,
  mutation?: Mutation<unknown, unknown, unknown, unknown>,
  variables?: unknown
) => {
  try {
    if (!isRefreshing) {
      isRefreshing = true;
      failedQueue.push({ query, mutation, variables });
      const { csrf_token } = await refreshToken().catch((err) => {
        if (err.status === 403 || err.status === 401) localStorage.removeItem("user");
      });
      setScrfToken(csrf_token);
      processFailedQueue();
    } else failedQueue.push({ query, mutation, variables });
  } catch {
    removeScrfToken();
    if (!isRedirecting) {
      isRedirecting = true;
      window.location.reload();
    }
  }
};

const processFailedQueue = () => {
  failedQueue.forEach(({ query, mutation, variables }) => {
    if (mutation) {
      const { options } = mutation;
      mutation.setOptions({ ...options, variables });
      mutation.execute();
    }
    if (query) query.fetch();
  });
  isRefreshing = false;
  failedQueue = [];
};
